function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEditIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 18 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "m13.577.002.14.001c.272.024.515.103.734.27.063.049.123.097.179.154l-.075-.068.121.108c.29.287.58.576.869.866l.866.868 1.134 1.134.017.018c.04.04.079.082.114.126.142.179.268.374.302.605.041.275.03.525-.079.782a1.402 1.402 0 0 1-.3.449l-.898.896-2.09 2.09-.042.039-1.477 1.477-1.136 1.137-1.523 1.523-.46.459-.434.434-2.236 2.235-.252.252-.612.613-.155.155-.188.187-.212.212c-.242.242-.482.485-.724.723a.838.838 0 0 1-.573.252c-.08.002-.157 0-.236 0H.772A.783.783 0 0 1 0 17.226v-3.813l.23-.546 9.466-9.465.023-.023L12.635.464l.033-.03c.114-.112.234-.22.38-.286.211-.097.433-.164.67-.145zM10.28 5.064 1.54 13.96v2.492h2.743l3.946-3.954.455-.458.43-.43.402-.404 1.198-1.199.28-.283.587-.587.272-.273.076-.076.135-.134.107-.108.601-.6.196-.196zm3.37-3.43-2.288 2.33 1.957 1.956.74.74 2.074-2.074.238-.235-.123-.12-.136-.132-1.581-1.58-.698-.7-.11-.112Z",
    style: {
      strokeWidth: 1.08
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditIcon);
export default __webpack_public_path__ + "static/media/edit-icon.1b685dbc647cd0e057f338ae9e7af410.svg";
export { ForwardRef as ReactComponent };